import * as ApiManager from './_manager'

export const auth = {
    register: (payload) => {
        return ApiManager.callApi('/guest/auth/register', payload);
    },

    login: (payload) => {
        return ApiManager.callApi('/guest/auth/login', payload)
    },

    verifyOtp: (payload) => {
        return ApiManager.callApi('/guest/auth/verify', payload)
    },

    logout: (payload) => {
        return ApiManager.callApi('/guest/auth/logout', payload);
    },

    loginWithUploadLink: (payload) => {
        return ApiManager.callApi('/guest/auth/loginWithUploadLink', payload);
    },
}
